import React, { useContext, useState, useEffect } from 'react';
import { Collapse, Navbar, Nav } from 'reactstrap';
import classNames from 'classnames';
import AppContext from '../../context/Context';
import Logo from './Logo';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import is from 'is_js';

const NavbarTop = ({ currentuserdata, organizationLogo }) => {
  const {
    showBurgerMenu,
    setShowBurgerMenu,
    isTopNav,
    isVertical,
    isCombo,
    navbarCollapsed,
    setNavbarCollapsed
  } = useContext(AppContext);

  // Estado para determinar si estamos en dispositivo móvil
  const [isMobile, setIsMobile] = useState(is.mobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(is.mobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Selecciona la clase según si es móvil o no
  const navbarClass = isMobile ? 'my-custom-navbar' : 'navbar-top';

  const handleBurgerMenu = () => {
    if (isTopNav && !isCombo) {
      setNavbarCollapsed(!navbarCollapsed);
    }
    if (isCombo || isVertical) {
      setShowBurgerMenu(!showBurgerMenu);
    }
  };

  return (
    <Navbar
      light
      className={classNames(
        'navbar-glass fs--1 font-weight-semi-bold row sticky-kit',
        navbarClass
      )}
      expand={isTopNav && topNavbarBreakpoint}
    >
      <div
        className={classNames('toggle-icon-wrapper mr-md-3 mr-2', {
          'd-lg-none': isTopNav && !isCombo,
          [`d-${navbarBreakPoint}-none`]: isVertical || isCombo
        })}
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </div>

      <div className="d-flex align-items-center">
        <Logo
          at="navbar-top"
          width={180}
          id="topLogo"
          currentuserdata={currentuserdata}
          organizationLogo={organizationLogo}
          style={{ margin: '0 auto' }} // Estilos para centrar la imagen
        />
      </div>

      {isTopNav ? (
        <Collapse navbar isOpen={navbarCollapsed} className="scrollbar">
          <Nav navbar>
            <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} />
          </Nav>
        </Collapse>
      ) : (
        <Nav navbar className={`align-items-center d-none d-${topNavbarBreakpoint}-block`} />
      )}

      <TopNavRightSideNavItem />
    </Navbar>
  );
};

export default NavbarTop;
